import React from "react";

// components
import { ColumnDef } from "@tanstack/react-table";
import { ISimpleData, IStateCountry } from "../../../store/types/misc";
import DataTable from "../../../component/element/table";
import ItemAction from "../../../component/ui/action/ItemAction";

// constants and icon
import { format_date_time } from "../../../services/convert/date";

// router and services
import { useNavigate } from "react-router-dom";
import { get_service_requests } from "../../../services/apis/requests";
import { useAppDispatch, useAppSelector } from "../../../store";
import { IRequest } from "../../../store/types/request";

const ServiceRequest = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const requests = useAppSelector(({ request }) => request.requests);
  // const loading = useAppSelector(({ request }) => request.loading);
  const current_page = useAppSelector(({ request }) => request.current_page);

  const onLoad = React.useCallback(() => {
    get_service_requests(dispatch, current_page);
  }, [current_page, dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<IRequest>[] = [
    {
      accessorKey: "service",
      header: "Name",
      cell: ({ row }) => {
        const data = row.original;
        return <span>{data?.service?.name || data?.document?.name}</span>;
      },
    },
    {
      accessorKey: "state",
      header: "Location",
      cell: ({ getValue }) => {
        const state = getValue() as IStateCountry;
        return (
          <span className="capitalize">
            {`${state.name}, ${state.country.name}`}
          </span>
        );
      },
    },
    {
      accessorKey: "payment_link",
      header: "Order Type",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <span className="capitalize">
            {data.service ? "service" : "document"}
          </span>
        );
      },
    },
    {
      accessorKey: "request_status",
      header: () => "Status",
      cell: ({ getValue }) => {
        const request_status = getValue() as ISimpleData;
        return <span>{request_status?.name}</span>;
      },
    },
    {
      accessorKey: "created_at",
      header: "Order Date",
      cell: ({ getValue }) => {
        const created_at = getValue() as Date;
        return (
          <span className="capitalize">
            {created_at && format_date_time(created_at)}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue }) => {
        const id = getValue() as string;
        return (
          <ItemAction
            show_edit={false}
            show_delete={false}
            onView={() => navigate("/request/" + id)}
            onEdit={() => null}
            onDelete={() => null}
          />
          // <FaEye
          //   size={25}
          //   color="blue"
          //   onClick={() => navigate("/request/" + id)}
          //   className="cursor-pointer"
          // />
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <h2 className="font-bold text-[1.4rem] capitalize">Requests</h2>

      <div className="bg-[white] mt-4">
        <DataTable columns={columns} data={requests} />
      </div>
    </div>
  );
};

export default ServiceRequest;
